import intl from "react-intl-universal";
import PropTypes from "prop-types";
import { Col, Row } from "react-flexbox-grid";
import { isCurrentRefuelingPointPercentDisabled, userCanEditStockPolicies } from "../../validations";
import InputNumber from "components/input-number";
import { formatNumber } from "utils/format";
import { validatesArrayHasValue } from "utils/custom-functions";
import Input from "components/input";

const INTL_GERAL = "master-data.general-configuration";
const TIPO_ALGORITMO_POLITICA_SILOS = 3;

const InventoryConfigurationByStorageLocation = ({
  inventoryStorageLocations,
  selectedTipoAlgoritmo,
  updateStorageLocationsInventory,
}) => (
  <>
    {validatesArrayHasValue(inventoryStorageLocations) &&
      inventoryStorageLocations.map((x) => (
        <>
          <label className="label-style">
            {`${intl.get(INTL_GERAL + ".currentInventory")} - ${intl.get("master-data.general-configuration.storageLocationAbbreviation")} ${x.Description}`}
          </label>
          <div className="container__general-form">
            <Row>
              <Col xs={2} lg={2} md={2}>
                <InputNumber
                  type="default"
                  required
                  label={intl.get(`${INTL_GERAL}.minStock`)}
                  name="CurrentMinimumStock"
                  value={x.CurrentMinimumStock}
                  onChange={(_value) => updateStorageLocationsInventory(x.StorageLocationId, "CurrentMinimumStock", _value)}
                  disabled={!userCanEditStockPolicies()}
                  data-testid='input-current-minimum-stock'
                />
              </Col>
              <Col xs={2} lg={2} md={2}>
                <InputNumber
                  type="default"
                  required
                  label={intl.get(`${INTL_GERAL}.maxStock`)}
                  name="CurrentMaximumStock"
                  value={x.CurrentMaximumStock}
                  onChange={(_value) => updateStorageLocationsInventory(x.StorageLocationId, "CurrentMaximumStock", _value)}
                  disabled={selectedTipoAlgoritmo == TIPO_ALGORITMO_POLITICA_SILOS || !userCanEditStockPolicies()}
                  data-testid='input-current-maximum-stock'
                />
              </Col>
              <Col xs={2} lg={2} md={2}>
                <InputNumber
                  disabled={isCurrentRefuelingPointPercentDisabled(selectedTipoAlgoritmo)}
                  required
                  label={intl.get(`${INTL_GERAL}.refuelingPoint`)}
                  type="default"
                  maxLength="3"
                  value={x.CurrentRefuelingPointPercent}
                  name="CurrentRefuelingPointPercent"
                  onChange={(_value) => updateStorageLocationsInventory(x.StorageLocationId, "CurrentRefuelingPointPercent", _value)}
                  data-testid='input-current-refueling-point-percent'
                />
              </Col>
              <Col xs={2} lg={2} md={2}>
                <Input
                  disabled
                  label={intl.get(`${INTL_GERAL}.inQuantity`)}
                  name="CurrentRefuelingPoint"
                  value={formatNumber(x.CurrentRefuelingPoint)}
                />
              </Col>
            </Row>
          </div>
        </>
      ))}
  </>
);

InventoryConfigurationByStorageLocation.propTypes = {
  inventoryStorageLocations: PropTypes.object.isRequired,
  selectedTipoAlgoritmo: PropTypes.number.isRequired,
  updateStorageLocationsInventory: PropTypes.func.isRequired
};

export default InventoryConfigurationByStorageLocation;
